module.exports = __webpack_public_path__ + "img/preload.ca77b313.svg";